import '@ghq-abi/design-system-v2/css';
import '@ghq-abi/design-system/css';
import 'core-js/actual';

import { type AppProps } from 'next/app';
import dynamic from 'next/dynamic';
import { initializeAxeCore } from '@shared/lib/axeCore';
import { isClient, isLocal } from '@shared/lib/environments';

import { globalStyles } from '~/app/styles/global';

import '@ab-inbev-labs/ux-react-components/dist/index.css';
import '@ab-inbev-labs/ux-react-components/dist/style/globals.css';
import '@ab-inbev-labs/ux-react-components/dist/style/hexa.css';
import '@ab-inbev-labs/ux-react-components/dist/style/theme-corporateTech.css';
import '~/app/styles/globals.css';

if (isClient() && isLocal()) {
  initializeAxeCore();
}

globalStyles();

const ClientAppShell = dynamic(() => import('@app/providers/ClientAppShell'), {
  ssr: false,
});

export default function App({ Component, pageProps, router }: AppProps) {
  // The local fixture is deliberately isolated from the authenticated shell:
  // AuthClientProvider can otherwise redirect an anonymous browser to the
  // corporate sign-out endpoint before the fixture's server guard is reached.
  if (router.pathname === '/__test/tolgee') {
    return <Component {...pageProps} />;
  }
  return <ClientAppShell Component={Component} pageProps={pageProps} />;
}
